<template>
  <div class="container">
    <div
      class="navigationVideoLayouts  col-xl-5 col-lg-12 order-xl-2 order-lg-1 "
    >
      <PageNavigations @set-page="setPageInParent" />
      <VideoLayout :pageNum="currPageNum" />
    </div>
    <PdfDisplay class="col-xl-7 col-lg-12 order-xl-1 order-lg-2" />
  </div>
</template>

<script>
import PdfDisplay from "./pagestructure/PdfDisplay.vue";
import PageNavigations from "./pagestructure/PageNavigations.vue";
import VideoLayout from "./pagestructure/VideoLayout.vue";
export default {
  name: "HomePage",
  components: {
    PdfDisplay,
    PageNavigations,
    VideoLayout,
  },
  data: () => {
    return {
      currPageNum: 1,
    };
  },

  methods: {
    setPageInParent: function(v) {
      this.$router.replace({ path: "/p" + v }).catch((err) => {
        if (
          err.name !== "NavigationDuplicated" &&
          !err.message.includes(
            "Avoided redundant navigation to current location"
          )
        ) {
          console.err(err);
        }
      });

      this.currPageNum = v;
    },
  },
};
</script>

<style scoped>
.container {
  min-height: 100vh;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.navigationVideoLayouts {
  width: 100%;
  margin: 10px 0px 10px 5px;
  padding: 0px;
}
@media (max-width: 1200px) {
  .container {
    flex-direction: column;
  }
  .navigationVideoLayouts {
    width: 100%;
    margin: 0px;
    padding: 0px;
  }
}
</style>
